import gql from "graphql-tag";

export const ADD_CHARACTERiSTIC_MUTATION = gql`
  mutation AddCharacteristicMutation(
    $shortcut: String!
    $categoryId: ID!
    $dataType: String!
    $characteristicUnitsId: ID!
    $keys: [CharactersticKeyInput!]!
    $isCritical: Boolean!
  ) {
    addCharacteristic(
      characteristicInput: {
        shortcut: $shortcut
        categoryId: $categoryId
        dataType: $dataType
        characteristicUnitsId: $characteristicUnitsId
        keys: $keys
        isCritical: $isCritical
      }
    )
  }
`;
